// import request from '@/router/axios'
import {request} from '@/network/request'

// export function fetchList(query) {
//   return request({
//     url: '/gaoligong/dnabar/page',
//     method: 'get',
//     params: query
//   })
// }
// export function addObj(obj) {
//   return request({
//     url: '/gaoligong/dnabar',
//     method: 'post',
//     data: obj
//   })
// }
//
// export function getObj(id) {
//   return request({
//     url: '/gaoligong/dnabar/' + id,
//     method: 'get'
//   })
// }
//
// export function delObj(id) {
//   return request({
//     url: '/gaoligong/dnabar/' + id,
//     method: 'delete'
//   })
// }
//
// export function putObj(obj) {
//   return request({
//     url: '/gaoligong/dnabar',
//     method: 'put',
//     data: obj
//   })
// }

export function fetchList(data) {
  return request({
    url: '/gaoligong/dnabarplant/getDnaHomeBarPlantList',
    method: 'post',
    data: data
  })
}

export function addObj(obj) {
  return request({
    url: '/gaoligong/dnabarplant',
    method: 'post',
    data: obj
  })
}

export function getObj(id) {
  return request({
    url: '/gaoligong/dnabarplant/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/dnabarplant/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/dnabarplant',
    method: 'put',
    data: obj
  })
}
